
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/ntt",
      function () {
        return require("private-next-pages/cases/ntt/index.tsx");
      }
    ]);
  